import { LoginArImage, SliderImg1, SliderImg2 } from "../../components/styled/AllImages";

export const AuthSlides = [
  <img alt="cloud-archive-preview" src={SliderImg1} />,
  <img alt="cloud-archive-preview" src={SliderImg1} />,
  <img alt="cloud-archive-preview" src={SliderImg1} />,
  <img alt="cloud-archive-preview" src={SliderImg1} />,
];
export const AuthSlidesAr = [
  <img alt="cloud-archive-preview" src={LoginArImage} />,
  <img alt="cloud-archive-preview" src={LoginArImage} />,
  <img alt="cloud-archive-preview" src={LoginArImage} />,
  <img alt="cloud-archive-preview" src={LoginArImage} />,
];